const BASE_URL = process.env.REACT_APP_APPLICATION_BASE_URL;

const isMobileOrTablet = () => /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);

const objectToGetParams = (object) => {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);

  return params.length > 0 ? `?${params.join('&')}` : '';
};

export const getTwitterShareURL = (text) => `https://twitter.com/share/${objectToGetParams({
  url: BASE_URL,
  text,
})}`;

export const getFacebookShareURL = (quote) => `https://www.facebook.com/sharer/sharer.php${objectToGetParams({
  u: BASE_URL,
  quote,
})}`;

export const getWhatsAppShareURL = (text) => `https://${isMobileOrTablet() ? 'api' : 'web'}.whatsapp.com/send${objectToGetParams({ text: `${text} ${BASE_URL}` })}`;

export const getLinkedInShareURL = (title) => `https://linkedin.com/shareArticle${objectToGetParams({ url: BASE_URL, mini: 'true', title })}`;